module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [(_vm.nothingFound) ? _c('PageError') : _c('ModuleLayout', [_c('ModuleSidebar', {
    attrs: {
      "sidebar": _vm.sidebar
    }
  }, [_c('ModuleButton', {
    attrs: {
      "slot": "btn",
      "isDisabled": !_vm.isAuthorized || !_vm.isPublishedConstructor,
      "isAddModuleBtnMode": !_vm.isModuleSaved
    },
    on: {
      "toggledModule": _vm.addOrRemoveToBasket
    },
    slot: "btn"
  })], 1), _c('ModuleMain', {
    attrs: {
      "main": _vm.main
    }
  })], 1), _c('ModuleFooter', {
    attrs: {
      "items": _vm.footer
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b54cd1","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/modules/card/ModuleCard.vue
// module id = aa50398e999d24ee4a99
// module chunks = 48